import * as Yup from "yup";
import i18n from "../i18n";
import {
  DOC_TYPE_ID,
  Attachments as AttachmentsType,
} from "../constants/common";

export const createVisitorDetailsGroupCardSchema = (
  isAttachments: AttachmentsType,
  isVip?: boolean
) => {
  return Yup.object({
    name: Yup.string()
      .required(i18n.language === "en" ? "Name is required." : "الاسم مطلوب.")
      .matches(
        /^[^0-9]*$/,
        i18n.language === "en"
          ? "Name must not contain numbers."
          : "يجب ألا يحتوي الاسم على أرقام."
      ),
    companyName: Yup.string().when([], {
      is: () => isVip,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "Organization name is required."
            : "الجهة التابع لها مطلوب."
        ),
    }),
    nationality: Yup.string().when([], {
      is: () => isVip,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "Nationality is required."
            : "الجنسية مطلوبة."
        ),
    }),
    number: Yup.string().when([], {
      is: () => isVip,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema
          .matches(
            /^\d{1,14}$/,
            i18n.language === "en"
              ? "Enter a valid number."
              : "أدخل رقماً صحيحاً."
          )
          .required(
            i18n.language === "en"
              ? "Mobile Number is required."
              : "رقم الجوال مطلوب."
          ),
    }),
    email: Yup.string()
      .email(
        i18n.language === "en" ? "Invalid email" : "البريد الإلكتروني غير صالح."
      )
      .required(
        i18n.language === "en"
          ? "Email is required."
          : "البريد الإلكتروني مطلوب."
      ),
    dateOfBirth: Yup.string().when([], {
      is: () => isVip,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "Date of birth is required."
            : "تاريخ الميلاد مطلوب."
        ),
    }),

    idType: Yup.number().when([], {
      is: () => isVip,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.required(
          i18n.language === "en" ? "ID Type is required." : "نوع الهوية مطلوب."
        ),
    }),
    iqama: Yup.string().when([], {
      is: () => isVip,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.nullable().when("idType", {
          is: DOC_TYPE_ID.IQAMA,
          then: (schema) =>
            schema
              .matches(
                /^\d{1,10}$/,
                i18n.language === "en"
                  ? "Enter a valid iqama number."
                  : "أدخل رقم إقامة صالح."
              )
              .required(
                i18n.language === "en"
                  ? "Iqama is required."
                  : "الإقامة مطلوبة."
              ),
          otherwise: (schema) => schema.nullable(),
        }),
    }),
    iqamaExpiryDate: Yup.string()
      .optional()
      .when([], {
        is: () => isVip,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) =>
          schema.nullable().when("idType", {
            is: DOC_TYPE_ID.IQAMA,
            then: (schema) =>
              schema.required(
                i18n.language === "en"
                  ? "Iqama expiry is required."
                  : "تاريخ انتهاء الإقامة مطلوب."
              ),
            otherwise: (schema) => schema.nullable(),
          }),
      }),
    eid: Yup.string().when([], {
      is: () => isVip,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.nullable().when("idType", {
          is: DOC_TYPE_ID.NATIONAL_ID,
          then: (schema) =>
            schema
              .matches(
                /^\d{1,10}$/,
                i18n.language === "en"
                  ? "Enter a valid National ID."
                  : "أدخل رقم هوية وطنية صالح."
              )
              .required(
                i18n.language === "en"
                  ? "National ID is required."
                  : "الهوية الوطنية مطلوبة."
              ),
          otherwise: (schema) => schema.nullable(),
        }),
    }),
    eidExpiryDate: Yup.string()
      .optional()
      .when([], {
        is: () => isVip,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) =>
          schema.nullable().when("idType", {
            is: DOC_TYPE_ID.NATIONAL_ID,
            then: (schema) =>
              schema.required(
                i18n.language === "en"
                  ? "National ID expiry is required."
                  : "تاريخ انتهاء الهوية الوطنية مطلوب."
              ),
            otherwise: (schema) => schema.nullable(),
          }),
      }),
    passportNumber: Yup.string().when([], {
      is: () => isVip,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.nullable().when("idType", {
          is: DOC_TYPE_ID.PASSPORT,
          then: (schema) =>
            schema.required(
              i18n.language === "en"
                ? "Passport Number is required."
                : "رقم الجواز مطلوب."
            ),
          otherwise: (schema) => schema.nullable(),
        }),
    }),
    passportExpiryDate: Yup.string()
      .optional()
      .when([], {
        is: () => isVip,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) =>
          schema.nullable().when("idType", {
            is: DOC_TYPE_ID.PASSPORT,
            then: (schema) =>
              schema.required(
                i18n.language === "en"
                  ? "Passport expiry date is required."
                  : "تاريخ انتهاء جواز السفر مطلوب."
              ),
            otherwise: (schema) => schema.nullable(),
          }),
      }),

    idTypeOtherName: Yup.string().when([], {
      is: () => isVip,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.nullable().when("idType", {
          is: DOC_TYPE_ID.OTHER,
          then: (schema) =>
            schema.required(
              i18n.language === "en"
                ? "Document name is required."
                : "اسم الوثيقة مطلوب."
            ),
          otherwise: (schema) => schema.nullable(),
        }),
    }),
    idTypeOtherNumber: Yup.string().when([], {
      is: () => isVip,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.nullable().when("idType", {
          is: DOC_TYPE_ID.OTHER,
          then: (schema) =>
            schema.required(
              i18n.language === "en"
                ? "Document number is required."
                : "رقم الوثيقة مطلوب."
            ),
          otherwise: (schema) => schema.nullable(),
        }),
    }),
    idTypeOtherExpiryDate: Yup.string()
      .optional()
      .when([], {
        is: () => isVip,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) =>
          schema.nullable().when("idType", {
            is: DOC_TYPE_ID.OTHER,
            then: (schema) =>
              schema.required(
                i18n.language === "en"
                  ? "Document expiry date is required."
                  : "تاريخ انتهاء الوثيقة مطلوب."
              ),
            otherwise: (schema) => schema.nullable(),
          }),
      }),

    visaNumber: Yup.string().when([], {
      is: () => isVip,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.nullable().when("idType", {
          is: DOC_TYPE_ID.VISA,
          then: (schema) =>
            schema
              .required(
                i18n.language === "en"
                  ? "Visa number is required"
                  : "رقم التأشيرة مطلوب"
              )
              .matches(
                /^[A-Z0-9][A-Z0-9\s-]{5,13}$/,
                i18n.language === "en"
                  ? "Enter a valid visa number"
                  : "أدخل رقم تأشيرة صالحًا"
              ),
          otherwise: (schema) => schema.nullable(),
        }),
    }),
    visaExpiryDate: Yup.string()
      .optional()
      .when([], {
        is: () => isVip,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) =>
          schema.nullable().when("idType", {
            is: DOC_TYPE_ID.VISA,
            then: (schema) =>
              schema.required(
                i18n.language === "en"
                  ? "Visa Expiry Date is required."
                  : "يجب تحديد تاريخ انتهاء صلاحية التأشيرة."
              ),
            otherwise: (schema) => schema.nullable(),
          }),
      }),

    uploadPhoto: Yup.mixed().notRequired(),
    // .when([], {
    //   is: () => isAttachments.havePhoto,
    //   then: (schema) => schema.notRequired(),
    //   otherwise: (schema) =>
    //     schema
    //       .nullable()
    //       .required(
    //         i18n.language === "en"
    //           ? "Photo upload is required."
    //           : "تحميل الصورة مطلوب."
    //       ),
    // }),
    uploadIqama: Yup.mixed().when([], {
      is: () => isVip || isAttachments.haveIqama,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.nullable().when("idType", {
          is: DOC_TYPE_ID.IQAMA,
          then: (schema) =>
            schema.required(
              i18n.language === "en"
                ? "Iqama upload is required."
                : "يتطلب تحميل الإقامة"
            ),
          otherwise: (schema) => schema.nullable(),
        }),
    }),

    uploadEid: Yup.mixed().when([], {
      is: () => isVip || isAttachments.haveEid,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.nullable().when("idType", {
          is: DOC_TYPE_ID.NATIONAL_ID,
          then: (schema) =>
            schema.required(
              i18n.language === "en"
                ? "National ID upload is required."
                : "يجب تحميل الهوية الوطنية."
            ),
          otherwise: (schema) => schema.nullable(),
        }),
    }),
    uploadPassport: Yup.mixed().when([], {
      is: () => isVip || isAttachments.havePassport,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.nullable().when("idType", {
          is: DOC_TYPE_ID.PASSPORT,
          then: (schema) =>
            schema.required(
              i18n.language === "en"
                ? "Passport upload is required."
                : "تحميل جواز السفر مطلوب."
            ),
          otherwise: (schema) => schema.nullable(),
        }),
    }),

    uploadIdOther: Yup.mixed().when([], {
      is: () => isVip || isAttachments.haveOthers,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.nullable().when("idType", {
          is: DOC_TYPE_ID.OTHER,
          then: (schema) =>
            schema.required(
              i18n.language === "en"
                ? "Other document upload is required."
                : "يتطلب تحميل مستند آخر"
            ),
          otherwise: (schema) => schema.nullable(),
        }),
    }),

    uploadVisa: Yup.mixed().when([], {
      is: () => isVip || isAttachments.haveVisa,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.nullable().when("idType", {
          is: DOC_TYPE_ID.VISA,
          then: (schema) =>
            schema.required(
              i18n.language === "en"
                ? "Visa upload is required."
                : "يجب تحميل التأشيرة."
            ),
          otherwise: (schema) => schema.nullable(),
        }),
    }),

    uploadHostEmployeeCard: Yup.mixed().when([], {
      is: () => isAttachments.haveHostEmployeeCard,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema
          .nullable()
          .required(
            i18n.language === "en"
              ? "Host employee card is required."
              : "بطاقة الموظف المضيف مطلوبة."
          ),
    }),

    uploadVehicleRegLicense: Yup.mixed(),

    vehicleNo: Yup.string(),
  });
};
